<template>
  <div class="i-chat box">
    <div class="part-title">&diams;<span class="inline-title">互动</span></div>
    <div class="chats">
      <div class="chat" v-for="(item, index) in msgList" :key="index" @mouseenter="currentHoverItem=item">
        <div class="user">
          <div class="icon"></div>
          <div class="name">{{ item.userName }}:</div>
          <div class="del-btn" v-if="(userId === item.userId) && (currentHoverItem.id === item.id)" @click="deleteRecord(item)">删除</div>
        </div>
        <div class="msg">
          {{ item.content }}
        </div>
      </div>
    </div>
    <div class="input-msg">
      <el-input v-model="input" placeholder="请输入发布内容" style="width: 259px"></el-input>
      <div class="ok" @click="sendMessage">发送</div>
    </div>
  </div>
</template>

<script>
import interactionsApi from '@/api/interactions'
import { getUserId } from '@/utils/auth.js'

export default {
  data () {
    return {
      msgList: [
        {
          user: '游客',
          msg: '此处内容仅管理员和自己可见，内容文字过多的话使用展开全部交互按钮，发布类似文章反馈和调整意见，此处内容仅管理员和自己可见，此处内容仅管理员和自己可见，内容文字过多的话使用展开全部交互按钮，发布类似文章反馈和调整意见，此处内容仅管理员和自己可见，此处...'
        },
        {
          user: '管理员',
          msg: '感谢反馈，已调整改进！'
        }
      ],
      input: '',
      // sourceId: '105410002_001',
      // sourceName: '集驗簡易良方四卷',
      interactionId: '',
      currentHoverItem: {},
      userId: getUserId()
    }
  },
  mounted () {
    // console.log(getToken());
    this.getData();
  },
  methods: {
    getData () {
      this.msgList = [];
      if (this.sourceId === '') {
        return
      }
      interactionsApi.selectInteraction({
        sourceId: this.sourceId,
        pageSize: 100
      }).then((response) => {
        // console.log(response);
        if (response.rows.length > 0) {
          this.interactionId = response.rows[0].id;
          this.msgList = response.rows[0].records;
        }
      })
    },
    sendMessage () {
      interactionsApi.addInteractionRecord({
        content: this.input,
        sourceId: this.sourceId,
        sourceName: this.sourceName,
        interactionId: this.interactionId
      }).then(response => {
        this.getData();
        this.input = '';
      })
    },
    deleteRecord (item) {
      let that = this;

      function confirmDelete () {
        interactionsApi.delelteInteractionRecord({
          id: item.id,
          interactionId: item.interactionId
        }).then(response => {
          that.getData();
          that.$message({
            type: 'warning',
            message: '删除互动数据成功'
          });
        })
      }
      this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'del-model',
        type: 'warning'
      }).then(() => {
        confirmDelete();
      });
    }
  },
  props: {
    sourceId: String,
    sourceName: String
  },
  watch: {
    sourceId () {
      this.getData();
    }
  }
}
</script>

<style lang="less" scoped>
@import "~@/styles/variables.less";
.i-chat {
  width: 100%;
  height: 445px;
  margin-top: 12px;
  .chats {
    height: 320px;
    overflow-y: auto;
    .chat {
      // display: flex;
      // align-items: flex-start;
      background-color: #f5f2eb;
      padding: 9px 18px;
      .user {
        display: flex;
        align-items: center;

        .icon {
          width: 15px;
          height: 18px;
          background-image: url("~@/assets/images/chat-user-icon.png");
          background-size: 100% 100%;
        }
        .name {
          color: #4d4030;
          margin-left: 12px;
        }
      }
      .msg {
        color: #7a7374;
        width: 307px;
        margin-left: 8px;
      }
      .del-btn {
        color: #969494;
        .font-size-small;
        cursor: pointer;
        margin-left: 200px;
      }
    }
  }
  .input-msg {
    width: 97%;
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    /deep/ .el-input__inner {
      border: 2px solid #7c1823;
      height: 29px;
      line-height: 29px;
    }
    .ok {
      width: 70px;
      height: 29px;
      background: #7c1823;
      border-radius: 4px;
      font-weight: bold;
      .font-size-default;
      color: #FFFFFF;
      text-align: center;
      line-height: 29px;
      cursor: pointer;
    }
  }
}
</style>
